import { ActivityLinkHydration } from '../../../shared/modules/activity/dtos/activity-link-hydration.dto';

/**
 * Resolved related records for a supplier activity event, keyed by relation.
 */
export class SupplierActivityEventHydration {
  link?: ActivityLinkHydration;
}
